import React from 'react'
import tablePagination from 'styles/tablePagination.module.css'

type TablePaginationProps = {
  page: number
  totalPages: number
  pageInput: string
  onPageInputChange: (value: string) => void
  onPageInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onPageInputBlur: () => void
  onPrev: () => void
  onNext: () => void
  className?: string
  prevAriaLabel?: string
  nextAriaLabel?: string
  pageInputAriaLabel?: string
}

const TablePagination = ({
  page,
  totalPages,
  pageInput,
  onPageInputChange,
  onPageInputKeyDown,
  onPageInputBlur,
  onPrev,
  onNext,
  className,
  prevAriaLabel = 'Previous page',
  nextAriaLabel = 'Next page',
  pageInputAriaLabel = 'Page number',
}: TablePaginationProps) => {
  return (
    <div className={className || tablePagination.pagination}>
      <button
        type="button"
        className={tablePagination.paginationButton}
        onClick={onPrev}
        disabled={page <= 1}
        aria-label={prevAriaLabel}
      >
        &larr;
      </button>
      <span className={tablePagination.pageInfo}>
        <input
          className={tablePagination.pageInput}
          value={pageInput}
          onChange={e => onPageInputChange(e.target.value)}
          onKeyDown={onPageInputKeyDown}
          onBlur={onPageInputBlur}
          aria-label={pageInputAriaLabel}
        />
        / {totalPages}
      </span>
      <button
        type="button"
        className={tablePagination.paginationButton}
        onClick={onNext}
        disabled={page >= totalPages}
        aria-label={nextAriaLabel}
      >
        &rarr;
      </button>
    </div>
  )
}

export default TablePagination
